module.exports = __webpack_public_path__ + "img/组 2042@2x.b6a3b6e4.png";